import { Button, Stack, Typography } from '@mui/material';
import Image from 'src/components/image';
import PropTypes from 'prop-types';

export default function ErrorView({ variant }) {
  const getTitle = () => {
    switch (variant) {
      case '500':
        return 'Internal Server Error';
      case '404':
        return 'Page Not Found';
      case '403':
        return 'Forbidden';
      case '401':
        return 'Unauthorized';
      case 'invalid-link':
        return 'Invalid Link';
      default:
        return 'Page Not Found';
    }
  };

  const getIllustration = () => {
    switch (variant) {
      case '500':
        return (
          <Image
            src="/assets/illustrations/error-boundary.svg"
            sx={{
              width: '50%',
            }}
            alt="error-boundary"
          />
        );
      case '404':
        return (
          <Image
            src="/assets/illustrations/error-boundary.svg"
            sx={{
              width: '50%',
            }}
            alt="error-boundary"
          />
        );
      case '403':
        return (
          <Typography variant="h1" fontSize={200} fontWeight={600}>
            403
          </Typography>
        );
      case '401':
        return (
          <Image
            src="/assets/illustrations/lock.svg"
            sx={{
              width: '50%',
            }}
            alt="lock"
          />
        );

      case 'invalid-link':
        return (
          <Image
            src="/assets/illustrations/error-boundary.svg"
            sx={{
              width: '50%',
            }}
            alt="error-boundary"
          />
        );
      default:
        return (
          <Image
            src="/assets/illustrations/error-boundary.svg"
            sx={{
              width: '50%',
            }}
            alt="error-boundary"
          />
        );
    }
  };

  const getMessage = () => {
    switch (variant) {
      case '500':
        return "We've encountered an issue on our server. We're on it and will have things back to normal soon. Thank you for your patience";
      case '404':
        return "Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling";
      case '403':
        return 'You do not have the permissions to access this resource';
      case '401':
        return 'You do not have the appropriate permissions for this resource';
      case 'invalid-link':
        return 'The link you are trying to access is invalid';
      default:
        return "Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling";
    }
  };

  return (
    <Stack alignItems="center" justifyContent="center" spacing="35px">
      {getIllustration()}
      <Stack alignItems="center" justifyContent="center" maxWidth="70%">
        <Typography variant="h1" mb="20px">
          {getTitle()}
        </Typography>
        <Typography
          fontWeight={500}
          fontSize={18}
          color="content.primaryBlack2"
          mb="24px"
        >
          {getMessage()}
        </Typography>
        <Button
          variant="contained"
          sx={{
            width: '200px',
          }}
          href="/"
        >
          Go to Home
        </Button>
      </Stack>
    </Stack>
  );
}

ErrorView.propTypes = {
  variant: PropTypes.oneOf(['500', '404', '403', '401', 'invalid-link']),
};
